import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";
import Market from "../../images/location/atlanta/market-leader.png";
import {Link} from 'gatsby';

function Marketleader(props) {
    return (
        <div className="market p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="market-img">
                            <LazyLoadImage
                                src={Market}
                                effect="blur" alt="Tab_01" className="img-fluid"
                            />
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                        <div className="market-content">
                            <h2>Become a Market Leader in Atlanta with Our App Development Services</h2>
                            <p>Different business sectors are acknowledging Atlanta as a potential market for tech growth. Meanwhile, Business Facilities magazine has already been recognized consecutively for the second time as the no.1 tech hub spot in Georgia.</p>
                            <p>So, this is the best time to invest in technology development for your business to stay ahead of the competition. TekRevol has already initiated its operations to serve its clients with top-notch mobile app development in Atlanta. So, you can consult with us to discuss your idea.</p>
                            <Link to="/contact"
                                  className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Marketleader;